module.exports = __webpack_public_path__ + "img/chat-message-active.9f008afa.svg";